// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table_tableWrapperWithDraggableSorting__FcRFA table th:first-child {
  width: 30px;
}

.table_tableWrapperWithActions__3uVhv table th:last-child {
  width: 50px;
  text-align: center;
}

.table_tableWrapperWithOffset__lHkQS {
  padding-top: 12px;
  padding-bottom: 16px;
}

.table_tableWrapperWithSelectableRows__swpD7 .MuiPaper-elevation1 {
  display: none;
}

.table_tableRowPointer__1bkP3 {
  cursor: pointer;
}

.table_titleWrapper__7pPTO {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.table_title__G\\+1K3 {
  color: var(--mui-palette-grey-900);
}

.table_pagination__ftetd {
  display: flex;
  justify-content: flex-end;
}

.table_tableRowBorder__h5zb8 table {
  border-collapse: separate;
  border-spacing: 0 5px;
}

/* Apply styles to all <td> elements */
.table_tableRowBorder__h5zb8 td {
  border-top: 1px solid var(--mui-palette-grey-400);
  border-bottom: 1px solid var(--mui-palette-grey-400) !important;
}

/* Apply left border for the first <td> in each row */
.table_tableRowBorder__h5zb8 tr td:first-child {
  border-left: 1px solid var(--mui-palette-grey-400);
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}

/* Apply right border for the last <td> in each row */
.table_tableRowBorder__h5zb8 tr td:last-child {
  border-right: 1px solid var(--mui-palette-grey-400);
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  border-bottom: 1px solid var(--mui-palette-grey-400);
}

tr:has([data-role="selected-row"]) td {
  background: rgb(245 191 57 / 15%)
}

tr p {
  margin: 0;
}

.table_noMatchLabelHidden__7ZSYB .MuiTableRow-root td {
  border-bottom: none;
}`, "",{"version":3,"sources":["webpack://./../../packages/ui/dist/table/table.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,sCAAsC;AACtC;EACE,iDAAiD;EACjD,+DAA+D;AACjE;;AAEA,qDAAqD;AACrD;EACE,kDAAkD;EAClD,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA,qDAAqD;AACrD;EACE,mDAAmD;EACnD,6BAA6B;EAC7B,gCAAgC;EAChC,oDAAoD;AACtD;;AAEA;EACE;AACF;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".tableWrapperWithDraggableSorting table th:first-child {\n  width: 30px;\n}\n\n.tableWrapperWithActions table th:last-child {\n  width: 50px;\n  text-align: center;\n}\n\n.tableWrapperWithOffset {\n  padding-top: 12px;\n  padding-bottom: 16px;\n}\n\n.tableWrapperWithSelectableRows :global .MuiPaper-elevation1 {\n  display: none;\n}\n\n.tableRowPointer {\n  cursor: pointer;\n}\n\n.titleWrapper {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.title {\n  color: var(--mui-palette-grey-900);\n}\n\n.pagination {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.tableRowBorder table {\n  border-collapse: separate;\n  border-spacing: 0 5px;\n}\n\n/* Apply styles to all <td> elements */\n.tableRowBorder td {\n  border-top: 1px solid var(--mui-palette-grey-400);\n  border-bottom: 1px solid var(--mui-palette-grey-400) !important;\n}\n\n/* Apply left border for the first <td> in each row */\n.tableRowBorder tr td:first-child {\n  border-left: 1px solid var(--mui-palette-grey-400);\n  border-top-left-radius: 10px;\n  border-bottom-left-radius: 10px;\n}\n\n/* Apply right border for the last <td> in each row */\n.tableRowBorder tr td:last-child {\n  border-right: 1px solid var(--mui-palette-grey-400);\n  border-top-right-radius: 10px;\n  border-bottom-right-radius: 10px;\n  border-bottom: 1px solid var(--mui-palette-grey-400);\n}\n\ntr:has([data-role=\"selected-row\"]) td {\n  background: rgb(245 191 57 / 15%)\n}\n\ntr p {\n  margin: 0;\n}\n\n.noMatchLabelHidden :global .MuiTableRow-root td {\n  border-bottom: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tableWrapperWithDraggableSorting": `table_tableWrapperWithDraggableSorting__FcRFA`,
	"tableWrapperWithActions": `table_tableWrapperWithActions__3uVhv`,
	"tableWrapperWithOffset": `table_tableWrapperWithOffset__lHkQS`,
	"tableWrapperWithSelectableRows": `table_tableWrapperWithSelectableRows__swpD7`,
	"tableRowPointer": `table_tableRowPointer__1bkP3`,
	"titleWrapper": `table_titleWrapper__7pPTO`,
	"title": `table_title__G+1K3`,
	"pagination": `table_pagination__ftetd`,
	"tableRowBorder": `table_tableRowBorder__h5zb8`,
	"noMatchLabelHidden": `table_noMatchLabelHidden__7ZSYB`
};
export default ___CSS_LOADER_EXPORT___;
